import React, { useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { CheckCircle, Phone, Home, MessageCircle } from 'lucide-react';
import { track, whatsappUrl } from '../lib/track';

const Merci = () => {
  const fired = useRef(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Merci — demande envoyée | Frelon33™';

    // noindex : cette page ne doit pas être indexée
    const meta = document.createElement('meta');
    meta.name = 'robots';
    meta.content = 'noindex, nofollow';
    document.head.appendChild(meta);

    // Conversion réelle : la demande a bien été transmise (redirection FormSubmit).
    // Garde-fou : un seul envoi par montage (évite le double appel React StrictMode).
    if (!fired.current) {
      fired.current = true;
      track('lead_form_success', { method: 'formsubmit' });
    }

    return () => {
      document.head.removeChild(meta);
    };
  }, []);

  const handleCall = () => {
    track('phone_click', { location: 'merci' });
    window.location.href = 'tel:0676583038';
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50/60 via-white to-stone-50 flex items-center justify-center px-4 py-20">
      <div className="frelon-card border-0 frelon-depth-3 max-w-2xl w-full text-center py-12" data-testid="merci-page">
        <div className="relative inline-block mb-6">
          <CheckCircle className="h-20 w-20 text-green-500 mx-auto" />
        </div>
        <h1 className="text-3xl md:text-4xl font-black text-gray-900 mb-4">
          Votre demande a bien été transmise
        </h1>
        <p className="text-lg text-gray-600 leading-relaxed max-w-xl mx-auto mb-8">
          Merci de votre confiance. L'équipe <span className="frelon33-brand font-semibold">Frelon33™</span>{' '}
          vous recontactera dans les meilleurs délais.
        </p>

        <div className="bg-gradient-to-r from-green-50 to-yellow-50 border border-green-100 rounded-2xl p-6 mb-8">
          <p className="text-gray-700 font-medium mb-4">Une urgence ? Appelez-nous directement.</p>
          <button
            onClick={handleCall}
            className="frelon-btn frelon-btn-primary text-lg px-6 py-3 rounded-xl font-bold text-white inline-flex items-center gap-2"
            data-testid="merci-call-button"
            data-gtm-event="phone_click"
          >
            <Phone className="h-5 w-5" />
            06 76 58 30 38
          </button>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Link
            to="/"
            className="frelon-btn frelon-btn-secondary px-6 py-3 rounded-xl font-bold border border-gray-300 text-gray-700 hover:bg-gray-50 inline-flex items-center justify-center gap-2"
            data-testid="merci-home-link"
          >
            <Home className="h-5 w-5" />
            Retour à l'accueil
          </Link>
          <a
            href={whatsappUrl()}
            target="_blank"
            rel="noopener noreferrer"
            onClick={() => track('whatsapp_click', { location: 'merci' })}
            className="frelon-btn px-6 py-3 rounded-xl font-bold text-white inline-flex items-center justify-center gap-2"
            style={{ backgroundColor: '#25D366' }}
            data-testid="merci-whatsapp-link"
            data-gtm-event="whatsapp_click"
          >
            <MessageCircle className="h-5 w-5" />
            WhatsApp
          </a>
        </div>
      </div>
    </div>
  );
};

export default Merci;
